import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SchoolDaySetup } from "../shared/data.service";
import { SchoolDayUpdateRequest } from "../shared/SchoolDayUpdateRequest";

@Component({
	selector: "app-admin-setup-edit-school-day",
	templateUrl: "./admin-setup-edit-school-day.component.html",
	styleUrls: ["./admin-setup-edit-school-day.component.css"],
})
export class AdminSetupEditSchoolDayComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: DataService_SchoolDaySetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedSchoolDay = this.dialogConfig.data.SelectedSchoolDay;

		//Update values
		this.Desc = this.SelectedSchoolDay.DayDesc;

		//Get data from DB
		this.loadBellSchedule();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SchoolID: any;
	SelectedSchoolDay: any;

	//Data from DB
	Desc: any;

	BellScheduleID: any;
	lstBellSchedule: any = [];

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////
	loadBellSchedule() {
		var result = this.adminSetupService.LoadBellSchedule(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstBellSchedule = response;

				this.lstBellSchedule.unshift({
					BellScheduleID: -1,
					BellScheduleDesc: "None",
				});

				this.BellScheduleID = this.lstBellSchedule[0].BellScheduleID;

				if (this.SelectedSchoolDay.Default_BellScheduleID != undefined && this.SelectedSchoolDay.Default_BellScheduleID > 0) {
					this.BellScheduleID = this.SelectedSchoolDay.Default_BellScheduleID;
				}
			},
			(error) => {}
		);
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onUpdate() {
		let parms: SchoolDayUpdateRequest = {
			DayID: this.SelectedSchoolDay.DayID,
			DayDesc: this.Desc,
			BellScheduleID: this.BellScheduleID,
		};

		var result = this.adminSetupService.SchoolDayUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Day was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the School Day",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
